import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AdProvider, useAdContext } from './AdProvider';

const GoogleAds = ({
  adKey,
  adClass,
  wrapperClass,
  style,
  slot,
  layout,
  layoutKey,
  format,
  responsive,
  restAdProps,
  client
}) => {
  const { addAdKey, removeAdKey } = useAdContext();

  useEffect(() => {
    addAdKey(adKey);

    return () => {
      removeAdKey(adKey);
    };
  }, [adKey, addAdKey, removeAdKey]);

  const restProps =
    process.env.NODE_ENV === 'production'
      ? { ...restAdProps }
      : { ...restAdProps, 'data-adtest': 'on' };

  return (
    <div className={`row ${wrapperClass}`}>
      <div className="col-md-12">
        <div className="adsWrapper">
          <ins
            style={style}
            className={`adsbygoogle ${adClass}`}
            data-ad-client={client || '9822821274784800'}
            data-ad-slot={slot}
            data-ad-layout={layout}
            data-ad-layout-key={layoutKey}
            data-ad-format={format}
            data-full-width-responsive={responsive}
            {...restProps}
          />
        </div>
      </div>
    </div>
  );
};

GoogleAds.propTypes = {
  adKey: PropTypes.string.isRequired,
  adClass: PropTypes.string,
  wrapperClass: PropTypes.string,
  style: PropTypes.shape({ display: PropTypes.string, }),
  client: PropTypes.string.isRequired,
  slot: PropTypes.string.isRequired,
  layout: PropTypes.string,
  layoutKey: PropTypes.string,
  format: PropTypes.string,
  responsive: PropTypes.oneOf(['true', 'false']),
  restAdProps: PropTypes.shape({}),
};

GoogleAds.defaultProps = {
  wrapperClass: '',
  adClass: '',
  style: { display: 'block' },
  format: 'auto',
  layout: '',
  layoutKey: '',
  responsive: false,
  client: process.env.REACT_APP_AD_CLIENT,
  restAdProps: { 'data-adtest': 'on' },
};

export default function GoogleAd(props) {
  return (
    <AdProvider>
      <GoogleAds {...props} />
    </AdProvider>
  );
}
